import { Breadcrumb, BreadcrumbHint } from '@sentry/react';

export type TMakeBreadcrumbFn = (
  breadcrumb: Breadcrumb,
  hint?: BreadcrumbHint,
) => Breadcrumb;

/**
 * Composes multiple breadcrumb modifier functions into a single function
 * Each function will receive the breadcrumb from the previous function and the same hint
 *
 * @param { ...TMakeBreadcrumbFn[] } makeBreadcrumbFns - The breadcrumb modifier functions to compose
 * @returns { TMakeBreadcrumbFn } A function that applies all the modifier functions in sequence
 */
export const composeMakeBreadcrumb = (
  ...makeBreadcrumbFns: TMakeBreadcrumbFn[]
): TMakeBreadcrumbFn => {
  return (breadcrumb: Breadcrumb, hint?: BreadcrumbHint): Breadcrumb => {
    if (makeBreadcrumbFns.length === 0) {
      return breadcrumb;
    }

    return makeBreadcrumbFns.reduce((currentBreadcrumb, fn) => {
      return fn(currentBreadcrumb, hint);
    }, breadcrumb);
  };
};
